import { render, staticRenderFns } from "./ImagenesSatelitalesFooter.vue?vue&type=template&id=663005c4&scoped=true"
import script from "./ImagenesSatelitalesFooter.vue?vue&type=script&lang=ts"
export * from "./ImagenesSatelitalesFooter.vue?vue&type=script&lang=ts"
import style0 from "./ImagenesSatelitalesFooter.vue?vue&type=style&index=0&id=663005c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663005c4",
  null
  
)

export default component.exports